var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTool(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.8456 47.0087C50.0307 47.012 50.2145 46.9784 50.3864 46.9098C50.5583 46.8413 50.7148 46.7392 50.8469 46.6095C50.9789 46.4798 51.0837 46.3251 51.1553 46.1544C51.2269 45.9838 51.2637 45.8006 51.2637 45.6155C51.2637 45.4304 51.2269 45.2472 51.1553 45.0766C51.0837 44.9059 50.9789 44.7512 50.8469 44.6215C50.7148 44.4918 50.5583 44.3897 50.3864 44.3211C50.2145 44.2526 50.0307 44.219 49.8456 44.2223C49.4761 44.2222 49.1217 44.3689 48.8603 44.6302C48.599 44.8914 48.4521 45.2458 48.452 45.6153C48.4524 45.9848 48.5993 46.339 48.8606 46.6003C49.1219 46.8616 49.4761 47.0083 49.8456 47.0087ZM40.2386 63.7555H59.4526V70.524H40.2386V63.7555ZM21.6797 92.7146C21.6797 96.6882 24.8806 100 28.8533 100H70.838C74.8116 100 78.0116 96.6873 78.0116 92.7146V82.3144H21.6797V92.7146ZM49.8456 85.0565C53.2155 85.0565 55.9472 87.7882 55.9472 91.1581C55.9472 94.5279 53.2155 97.2596 49.8456 97.2596C46.4758 97.2596 43.7441 94.5277 43.7441 91.1581C43.7485 87.79 46.4777 85.0607 49.8456 85.0565Z",
    fill: "url(#paint0_linear_4_54963)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4406 60.6987L60.5308 48.6882L51.374 31.4017V41.441C52.3559 41.8002 53.1801 42.4936 53.7018 43.3997C54.2235 44.3058 54.4095 45.3666 54.2271 46.3962C54.0448 47.4257 53.5057 48.3581 52.7045 49.0299C51.9033 49.7017 50.8912 50.0699 49.8456 50.0699C48.8001 50.0699 47.7879 49.7017 46.9867 49.0299C46.1855 48.3581 45.6465 47.4257 45.4641 46.3962C45.2818 45.3666 45.4678 44.3058 45.9895 43.3997C46.5112 42.4936 47.3353 41.8002 48.3172 41.441V31.4017L39.1692 48.6729L42.4996 60.6987H57.4406ZM70.838 0H28.8533C24.8806 0 21.6797 3.31266 21.6797 7.28537V14.1921H78.0116V7.28537C78.0116 3.31266 74.8107 0 70.838 0ZM57.2769 8.0786H42.4144C41.5701 8.0786 40.886 7.39454 40.886 6.55022C40.886 5.70589 41.5701 5.02183 42.4144 5.02183H57.2769C58.1212 5.02183 58.8052 5.70589 58.8052 6.55022C58.8052 7.39454 58.1212 8.0786 57.2769 8.0786Z",
    fill: "url(#paint1_linear_4_54963)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6797 79.2576H78.0116V17.2489H21.6797V79.2576ZM36.1832 47.7943L48.4945 24.5334C48.6245 24.2878 48.819 24.0822 49.057 23.9389C49.2951 23.7955 49.5677 23.7198 49.8456 23.7198C50.1235 23.7198 50.3962 23.7955 50.6342 23.9389C50.8723 24.0822 51.0667 24.2878 51.1967 24.5334L63.5081 47.7943C63.6866 48.1257 63.733 48.5124 63.6378 48.8766L60.5963 60.6987H60.9205C61.3349 60.7024 61.7318 60.8663 62.028 61.1562C62.3242 61.446 62.4967 61.8393 62.5094 62.2535V72.1325C62.5094 72.9768 61.764 73.5808 60.9205 73.5808H38.7707C37.9273 73.5808 37.1819 72.9768 37.1819 72.1325V62.2535C37.1945 61.8393 37.3671 61.446 37.6633 61.1562C37.9594 60.8663 38.3563 60.7024 38.7707 60.6987H39.3277L36.0603 48.9033C35.9568 48.5316 36.0009 48.1343 36.1832 47.7943ZM52.8904 91.1581C52.8904 92.8399 51.5275 94.2028 49.8456 94.2028C48.1637 94.2028 46.8009 92.8399 46.8009 91.1581C46.8009 89.4768 48.1637 88.1133 49.8456 88.1133C51.5275 88.1133 52.8904 89.4771 52.8904 91.1581Z",
    fill: "url(#paint2_linear_4_54963)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_54963",
    x1: 21.6797,
    y1: 45.7607,
    x2: 48.3208,
    y2: 127.463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_54963",
    x1: 21.6797,
    y1: 1.67435,
    x2: 52.6799,
    y2: 89.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4_54963",
    x1: 21.6797,
    y1: 19.3716,
    x2: 68.3381,
    y2: 123.087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTool);
export default __webpack_public_path__ + "static/media/tool.d455779ee12ac40e1a2c351ad6b7d74e.svg";
export { ForwardRef as ReactComponent };